var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 506,
    height: 491,
    viewBox: "0 0 506 491",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M412.391 380.024C386.86 410.24 345.961 422.639 300.397 418.178C254.836 413.717 204.664 392.398 160.702 355.254C116.74 318.109 87.3449 272.201 75.3411 228.024C63.3365 183.844 68.7336 141.448 94.2641 111.232C119.795 81.0154 160.694 68.6168 206.258 73.0777C251.819 77.5384 301.991 98.8575 345.953 136.002C389.915 173.146 419.31 219.055 431.314 263.232C443.318 307.412 437.921 349.807 412.391 380.024Z",
    fill: "url(#paint0_radial_912_2294)",
    fillOpacity: 0.1,
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 128.506,
    y: 149,
    width: 286.155,
    height: 17.4014,
    rx: 3,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 286.155,
    height: 17.4014,
    rx: 3,
    transform: "matrix(-1 0 0 1 476.775 248.384)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 128.506,
    y: 173.846,
    width: 221.487,
    height: 17.4014,
    rx: 3,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 221.487,
    height: 17.4014,
    rx: 3,
    transform: "matrix(-1 0 0 1 476.775 273.23)",
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 128.506,
    y: 198.692,
    width: 149.564,
    height: 17.4014,
    rx: 3,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 149.564,
    height: 17.4014,
    rx: 3,
    transform: "matrix(-1 0 0 1 476.775 298.076)",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.905 27.1846C127.534 35.2977 110.384 52.1115 116.763 54.4619C124.736 57.4 147.398 43.97 145.3 54.4619C143.621 62.8555 139.004 75.865 136.905 81.3206",
    stroke: "#E4E4E4",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_912_2294",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(253.328 245.628) rotate(129.114) scale(136.686 198.146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignImg);
export default __webpack_public_path__ + "static/media/designImg.56a7a5e87bf01e44677a3275b6c3a256.svg";
export { ForwardRef as ReactComponent };